module.exports = __webpack_public_path__ + "static/media/padel_icon.e01a7f20.svg";